import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import FormikTextField from "./FormikTextField";
import { localization } from "./formikLocalizationConfig";

const FormikAutocomplete = (props) => {
  const { setFieldValue, values } = useFormikContext();

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState(props.options);
  const [loadingFinished, setLoadingFinished] = useState(!props.getOptions);
  const loading = open && !loadingFinished && options.length === 0;
  const getValue = () => {
    const optionFound = options.find((o) => {
      if (props.returnProp) {
        return o[props.returnProp] === values[props.name];
      } else {
        return o.id === values[props.name];
      }
    });
    return optionFound ? optionFound : null;
  };

  const [value, setValue] = useState(getValue());

  useEffect(() => {
    setValue(getValue());
  }, [values[props.name]]);

  useEffect(() => {
    if (loading && props.getOptions) {
      props.getOptions()?.then(() => {
        setLoadingFinished(true); // Marcar la carga como finalizada
      });
    }
  }, [loading, loadingFinished]);

  useEffect(() => {
    setOptions(props.options);
  }, [props.options]);

  const onInputChange = (value, reason) => {
    if (reason === "reset" && value === "") {
      setFieldValue(props.name, null);
    }
    if (reason === "clear" && value === "" && props.handleOnClear) {
      props.handleOnClear();
    }
  };

  const onChange = (value) => {
    setFieldValue(
      props.name,
      value ? (props.returnProp ? value[props.returnProp] : value.id) : value
    );
    if (props.callBack) {
      props.callBack(value);
    }
  };

  const valueIsNotInOptions = () => {
    return (
      props.helperText &&
      values[props.name] &&
      (props.optionId
        ? !options.some((o) => o[props.optionId] === values[props.name])
        : !options.some((o) => o.nombre === values[props.name]))
    );
  };

  const filterOptions = createFilterOptions({
    stringify: (option) => props.filterOptions(option),
  });

  return (
    <Autocomplete
      sx={props.sx}
      open={open}
      options={options}
      freeSolo={props.freeSolo}
      loading={loading}
      onOpen={() => {
        setOpen(true);
        if (props.getOptions) {
          setLoadingFinished(false); // Reiniciar el estado de carga cuando el menú se abre
        }

      }}
      onClose={() => {
        setOpen(false);
      }}
      value={value}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => {
        const label = props.labelOption
          ? props.labelOption(option)
          : option.nombre;
        return props.formatLabelOption ? props.formatLabelOption(label) : label;
      }}
      filterOptions={props.filterOptions ? filterOptions : undefined}
      renderOption={(autoCompleteProps, option) => (
        <li {...autoCompleteProps} key={option.id ?? (props.renderOption ? props.renderOption(option) : option.nombre)}>
          {props.renderOption ? props.renderOption(option) : option.nombre}
        </li>
      )}
      onChange={(event, value) => onChange(value)}
      onInputChange={(event, value, reason) => onInputChange(value, reason)}
      disabled={props.disabled}
      {...localization.autocomplete}
      renderInput={(params) => {
        return (
          <FormikTextField
            {...params}
            name={props.name}
            label={props.label}
            variant={props.variant ? props.variant : "standard"}
            type={props.type}
            multiline={props.multiline}
            autoComplete={props.autoComplete}
            FormHelperTextProps={{
              sx: {
                color: "green",
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        );
      }}
    />
  );
};

export default FormikAutocomplete;
